<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <bear-date-picker
      v-model="form[options.Key]"
      :format="param.format"
      :value-format="param.valueFormat"
      :type="param.componentId"
      @change="inputChangeHandle"
      :disabled="options.Disabled"
      :is-string="param.isString"></bear-date-picker>
  </tender-form-label>
</template>
<script>
import _ from "lodash";
import BearDatePicker from "~@/date-picker/src";
import { mixForFormItem } from "../../../js/mixins";
import tenderHook from "../../../js/hooks";
import utils from "../../../js/utils";
export default {
  name: "FormInputDatePicker",
  mixins: [mixForFormItem],
  components: { BearDatePicker },
  created() {
    this.setDefaultValue();
  },
  data() {
    return {
    };
  },
  methods: {
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          this.setFormItemValue(options.Value || null);
        })
        .catch(() => null);
    },
    inputChangeHandle() {
      this.doSelectEvent();
    },
    doSelectEvent() {
      let { options = {} } = this;
      let { Refs = [] } = options;
      Refs.forEach((eRef) => {
        let [type] = eRef;
        switch (type) {
          case "houseHooks":
          case "trafficHooks":
            tenderHook.refEvent(false, this)
            break;
        }
      });
      this.doValidate();
    },
  },
};
</script>
